import React, { lazy } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import { SuspenseWrapper } from 'components/containers';

const FormRequestLazy = lazy(() =>
  import(/* webpackChunkName: "form-request" */ 'pages').then(({ FormRequest }) => ({
    default: FormRequest,
  })),
);

const PatientLazy = lazy(() =>
  import(/* webpackChunkName: "form-request-patient" */ 'pages/formRequest/patient/Patient').then(({ Patient }) => ({
    default: Patient,
  })),
);

const TypeLazy = lazy(() =>
  import(/* webpackChunkName: "form-request-type" */ 'pages/formRequest/type/Type').then(({ Type }) => ({
    default: Type,
  })),
);
const UploadTypeLazy = lazy(() =>
  import(/* webpackChunkName: "form-request-upload-type" */ 'pages/formRequest/type/Type').then(({ UploadType }) => ({
    default: UploadType,
  })),
);

const AuthSelectionLazy = lazy(() =>
  import(/* webpackChunkName: "record-request-authorization" */ 'pages/formRequest/authorization/AuthSelection').then(
    ({ AuthSelection }) => ({
      default: AuthSelection,
    }),
  ),
);

const AuthorizationLazy = lazy(() =>
  import(/* webpackChunkName: "form-request-authorization" */ 'pages/formRequest/authorization/Authorization').then(
    ({ Authorization }) => ({
      default: Authorization,
    }),
  ),
);

const GovtId = lazy(() => import('pages/formRequest/govtId/GovtId').then(({ GovtId }) => ({ default: GovtId })));
const SupportingDocs = lazy(() => import('pages/formRequest/supportingDocs/SupportingDocs').then(({ SupportingDocs }) => ({ default: SupportingDocs })));
const RequestInfo = lazy(() => import('pages/formRequest/requestInfo/RequestInfo').then(({ RequestInfo }) => ({ default: RequestInfo })));


const PaymentLazy = lazy(() =>
  import(/* webpackChunkName: "form-request-payment" */ 'pages/formRequest/payment/Payment').then(({ Payment }) => ({
    default: Payment,
  })),
);

const AddPaymentLazy = lazy(() =>
  import(/* webpackChunkName: "form-request-add-payment" */ 'pages/formRequest/addPayment/AddPayment').then(
    ({ AddPayment }) => ({
      default: AddPayment,
    }),
  ),
);

const ConfirmLazy = lazy(() =>
  import(/* webpackChunkName: "form-request-payment" */ 'pages/formRequest/confirm/Confirm').then(({ Confirm }) => ({
    default: Confirm,
  })),
);

const CreatePatientLazy = lazy(() =>
  import(/* webpackChunkName: "form-request-create-patient" */ 'pages/formRequest/patient/Patient').then(
    ({ CreatePatient }) => ({
      default: CreatePatient,
    }),
  ),
);

const RequestConfirmedLazy = lazy(() =>
  import(/* webpackChunkName: "form-request-confirmed" */ 'pages/formRequest/requestConfirmed/RequestConfirmed').then(
    ({ RequestConfirmed }) => ({
      default: RequestConfirmed,
    }),
  ),
);

const root = '/form-request';

type FormRequestRouterProps = {
  curruntStep: string | number;
  total: string | number
};

const RootRedirect = () => <Redirect to={`${root}/provider`} />
export const FormRequestRouter: React.FC<FormRequestRouterProps> = ({ curruntStep, total }) => (
  <Switch>
    <SuspenseWrapper>
      <Route path={`${root}/provider`}>
        <FormRequestLazy />
      </Route>
      <Route path={`${root}/patient`} render={() => curruntStep > 1 && curruntStep != total ? <PatientLazy /> : <RootRedirect />} />
      <Route path={`${root}/create-patient`} render={() => curruntStep > 1 && curruntStep != total ? <CreatePatientLazy /> : <RootRedirect />} />
      <Route path={`${root}/type`} render={() => curruntStep > 2 && curruntStep != total ? <TypeLazy /> : <RootRedirect />} />
      <Route path={`${root}/upload-type`} render={() => curruntStep > 2 && curruntStep != total ? <UploadTypeLazy /> : <RootRedirect />} />
      <Route path={`${root}/auth-type`} render={() => (curruntStep > 3 && curruntStep != total ? <AuthSelectionLazy /> : <RootRedirect />)} />
      <Route path={`${root}/authorization`} render={() => curruntStep > 4 && curruntStep != total ? <AuthorizationLazy /> : <RootRedirect />} />
      <Route path={`${root}/govt-id`} render={() => (curruntStep > 5 && curruntStep != total ? <GovtId /> : <RootRedirect />)} />
      <Route path={`${root}/supporting-docs`} render={() => (curruntStep > 6 && curruntStep != total ? <SupportingDocs /> : <RootRedirect />)} />
      <Route path={`${root}/request-info`} render={() => (curruntStep > 6 && curruntStep != total ? <RequestInfo /> : <RootRedirect />)} />
      <Route path={`${root}/payment`} render={() => curruntStep > 7 && curruntStep != total ? <PaymentLazy /> : <RootRedirect />} />
      <Route path={`${root}/add-payment`} render={() => curruntStep > 7 && curruntStep != total ? <AddPaymentLazy /> : <RootRedirect />} />
      <Route path={`${root}/confirm`} render={() => curruntStep > 8 && curruntStep != total ? <ConfirmLazy /> : <RootRedirect />} />
      <Route path={`${root}/requestConfirmed`} render={() => curruntStep == total ? <RequestConfirmedLazy /> : <RootRedirect />} />

      {/* <Redirect to={`${root}/provider`} /> */}
    </SuspenseWrapper>
  </Switch>
);
